import axios from 'axios';

import { useClaim } from '~/components/ClaimContainer';
import type { AnswerConductorAskRequest, ClaimConductorAskResponse } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

/**
 * Answers a question with an option it offered or the handler's own words, which Clive reads on its
 * next run. `fromOptions` is the handler's claim that the answer is one of the options, which the
 * conductor checks.
 *
 * A failure is reported here and rethrown, so the form keeps the pick and the words to retry with.
 * The asks are read again either way: a question Clive withdrew first settles on its card.
 */
export const useAnswerQuestion = (askId: string, onAskUpdate: () => Promise<void>) => {
  const { claim } = useClaim({ claimRequired: true });

  return async (answer: string, fromOptions: boolean): Promise<void> => {
    try {
      await axios.post<ClaimConductorAskResponse>(`/api/v1/claims/${claim.id}/conductor/asks/${askId}/answer`, {
        answer,
        from_options: fromOptions,
      } satisfies AnswerConductorAskRequest);
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    } finally {
      await onAskUpdate();
    }
  };
};
